var _defs, _rect, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 730.86 359.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8193a2;}.cls-2{fill:#f4f4f4;}.cls-3{fill:#af7e49;}.cls-4{fill:#c69162;}.cls-5{fill:#b5956f;}.cls-6{fill:#cda877;}.cls-7{fill:#fff;}.cls-8{fill:#eee;}.cls-9{opacity:0.4;}.cls-10{fill:#191f21;}.cls-11{fill:#214471;}.cls-12{fill:#485a63;}.cls-13{fill:#283237;}.cls-14{fill:#53b3e1;}.cls-15{fill:#c2e1ee;}.cls-16{fill:#eaeaea;}.cls-17{fill:#3669a2;}.cls-18{fill:#f8f8f8;}.cls-19{fill:none;stroke:#d0d0d0;stroke-miterlimit:10;}.cls-20,.cls-21{fill:#f9f9f9;}.cls-21{opacity:0.37;}.cls-22{fill:#dfdfdf;}.cls-23{fill:#d0d0d0;}.cls-24{fill:#656868;}.cls-25{fill:#505354;}.cls-26{fill:#3c3e3f;}.cls-27{opacity:0.6;}.cls-28{opacity:0.3;}.cls-29{fill:#f6bea2;}.cls-30{fill:#e09a78;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LOGINEM-CAMION") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 349.54,
    width: 730.86,
    height: 10.08,
    transform: "translate(730.86 709.17) rotate(-180)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.09,13.44c-.43-3.13,4-5.7,7.29-6,1.58-.14,3.22.11,4.72-.42,3.24-1.12,4.54-5.31,7.7-6.63,2.36-1,5.09-.11,7.36,1.05s4.56,2.61,7.13,2.77c2.21.14,4.65-.68,6.63.41,1.47.81,2.21,2.48,3.55,3.47a8.45,8.45,0,0,0,4.65,1.26,12.85,12.85,0,0,1,4.79.78A3.74,3.74,0,0,1,266.3,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.51,153.08c-.61-4.46,5.68-8.1,10.42-8.51,2.26-.19,4.61.16,6.74-.59,4.64-1.61,6.49-7.6,11-9.51,3.38-1.43,7.28-.15,10.55,1.48s6.52,3.72,10.18,4c3.18.21,6.63-1,9.43.59,2.08,1.15,3.17,3.55,5.08,5s4.31,1.67,6.63,1.8,4.73.15,6.85,1.12,3.87,3.2,3.42,5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M537.51,96.75c-.61-4.47,5.68-8.11,10.42-8.52,2.26-.18,4.61.16,6.74-.58,4.64-1.61,6.49-7.6,11-9.51,3.38-1.43,7.28-.16,10.55,1.47s6.52,3.72,10.18,4c3.18.2,6.63-1,9.43.58,2.08,1.16,3.17,3.55,5.08,5s4.31,1.68,6.63,1.8,4.73.15,6.85,1.12,3.87,3.21,3.42,5.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 98.67,
    y: 300.69,
    width: 68.4,
    height: 49.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.72,296.69c-.1,0,0,10.38,0,10.38h5.06V296.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 98.67,
    y: 300.69,
    width: 34.2,
    height: 49.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 56.67,
    y: 300.69,
    width: 68.4,
    height: 49.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.72,300.69c-.1,0,0,10.38,0,10.38h5.06V300.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 56.67,
    y: 300.69,
    width: 34.2,
    height: 49.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 105.17,
    y: 268.68,
    width: 44.53,
    height: 32.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.75,264.68c-.06,0,0,6.76,0,6.76h3.3v-6.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 105.17,
    y: 268.68,
    width: 22.26,
    height: 32.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 136.38,
    y: 264.42,
    width: 5.96,
    height: 4.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 138.3,
    y: 296.42,
    width: 2.98,
    height: 4.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.62,
    y: 331.13,
    width: 4.42,
    height: 9.32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Vehicle--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 295.39,
    y: 256.71,
    width: 343.83,
    height: 34.36
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.39,
    y: 256.71,
    width: 343.83,
    height: 34.36
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "542.29 281.02 542.29 323.08 507.63 323.08 493.74 302.95 240.71 302.95 240.71 281.02 542.29 281.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M544.45,147.81a2.59,2.59,0,0,1,2.68-2.44c13.69.57,78.72,3.55,92.09,10,10.23,4.92,21.45,23.3,29.35,35.68,5.67,8.88,18.19,28.57,20.72,38.65,2.14,8.51,3.44,26.23,3.29,35L689,311.2H630.07l-5.9-15.36A25.93,25.93,0,0,0,600,279.21H541.41V202Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M646.2,160.5c8.12,7.74,16.26,20.9,22.37,30.53,5.25,8.22,16.37,25.71,20,36.25.07.2.12.38.19.58-1.8-.5-4.56-1.51-5.42-3.22-1.3-2.58-3-11.41-23.44-44.76C653.67,169.72,647.6,163.77,646.2,160.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M574.72,157.05c15.07.86,47.74,3.1,58.17,6.64,13.6,4.65,28.86,40.64,29.58,42.22l10.28,26.33a1.14,1.14,0,0,1-.72,1.45,1.13,1.13,0,0,1-.36.06H645.09a8.46,8.46,0,0,1-3-.53l-69.91-26.06a8.09,8.09,0,0,1-5.26-7.57V164.38a7.34,7.34,0,0,1,7.34-7.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M669.79,231.16s-9.85-22.09-13.17-29.33c-5-10.93-16.68-33.29-24.57-35.7-7.26-2.17-28.11-4.82-57.47-6.5h-.28a4.78,4.78,0,0,0-4.76,4.76v36a4.38,4.38,0,0,0,2.84,4.08L624,210.85a14.36,14.36,0,0,1,10.26,6.38l9,13.65a4.8,4.8,0,0,0,1.64.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M669.79,231.16s-9.85-22.09-13.17-29.33c-5-10.93-16.68-33.29-24.57-35.7-7.26-2.17-28.11-4.82-57.47-6.5h-.28a4.78,4.78,0,0,0-4.76,4.76v36a4.38,4.38,0,0,0,2.84,4.08L624,210.85a14.36,14.36,0,0,1,10.26,6.38l9,13.65a4.8,4.8,0,0,0,1.64.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M625.9,211.24l17.56,19.56-9.72-64.94-2.43-.84,4.79,48.11a1.41,1.41,0,0,1-1.28,1.54,1.49,1.49,0,0,1-.66-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M693.73,269.21c.07-.84-.22-1.55-.65-1.55l-9.42-.87c-.77-.07-1.49,1.39-1.59,3.1l-.42,7.22c-.07,1.17.28,2.15.77,2.23L692,281c.44.08.85-.56.92-1.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 625.9,
    y: 302.96,
    width: 67.84,
    height: 27.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 647.84,
    y: 180.63,
    width: 15.38,
    height: 36.92,
    rx: 6.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M669.59,240.38h.77v-39a7,7,0,0,0-7-7h-1.86v.77h1.86a6.27,6.27,0,0,1,6.25,6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M664.31,240.42l2.15-36.5a4.64,4.64,0,0,0-4.41-4.87h-.18v.77a3.82,3.82,0,0,1,3.83,3.83,1.62,1.62,0,0,1,0,.22l-2.15,36.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 661.87,
    y: 236.86,
    width: 10.44,
    height: 12.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 665.73,
    y: 213.92,
    width: 4.24,
    height: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M630.3,158.1l-.92-.13-2.72-.32-10.53-1.21L576.88,152c-2.1-.22-4.22-.5-6.43-.7a12.3,12.3,0,0,0-3.37.22,13.42,13.42,0,0,0-3.23,1.22,12,12,0,0,0-4.88,5.08,11.66,11.66,0,0,0-1.13,3.5,14.28,14.28,0,0,0-.16,1.85V272.41h40.78a43.88,43.88,0,0,1,7,.34,27,27,0,0,1,21.4,17.09,20.27,20.27,0,0,1,.84,2.53,19.43,19.43,0,0,1,.6,2.59l.2,1.32.09.66,0,.65.07,1.33v.74c-.17-.17.24.26.2.22h51.72V239q0-1.83-.27-3.66A36.62,36.62,0,0,0,675.94,222q-3.2-6-6.19-11.61l-11-20.58-8.91-16.7c-.65-1.21-1.28-2.38-1.88-3.52-.31-.56-.58-1.12-.9-1.65a16.71,16.71,0,0,0-1.05-1.49,21.78,21.78,0,0,0-4.69-4.35,23.7,23.7,0,0,0-8-3.5,20.16,20.16,0,0,0-3-.48l.78.11c.5.08,1.25.21,2.22.44a23.72,23.72,0,0,1,8,3.53,21.77,21.77,0,0,1,4.64,4.35,12.62,12.62,0,0,1,1,1.48c.32.51.59,1.08.9,1.65l1.87,3.53,8.83,16.71c3.31,6.24,7,13.13,10.92,20.59l6.19,11.61A36.47,36.47,0,0,1,680,235.34a33.7,33.7,0,0,1,.25,3.63v60.68l.2-.19H628.94c-.06,0,.37.37.19.19v-.76l-.07-1.34v-.67l-.1-.66-.2-1.34a21.93,21.93,0,0,0-.61-2.64,21.47,21.47,0,0,0-.85-2.57,27.49,27.49,0,0,0-21.72-17.34,43.87,43.87,0,0,0-7-.33H558l.21.19V165a22.62,22.62,0,0,1,.15-3.68,11.48,11.48,0,0,1,1.09-3.42,11.6,11.6,0,0,1,4.76-4.95,12.27,12.27,0,0,1,3.15-1.2,12.12,12.12,0,0,1,3.29-.23c2.19.19,4.33.47,6.42.69l39.24,4.35,10.54,1.15,2.72.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M570,243.67a2.74,2.74,0,0,1-.61-.1,4.21,4.21,0,0,1-1.59-.63,4.06,4.06,0,0,1-1.62-2.11,4.71,4.71,0,0,1-.21-1.67,4.19,4.19,0,0,1,.47-1.8,4.05,4.05,0,0,1,3.49-2.13h16.82a4,4,0,0,1,3.94,3.53,4.42,4.42,0,0,1-.49,2.67,4,4,0,0,1-1.94,1.72,6.17,6.17,0,0,1-2.52.31h-6.93l-6.45.06h-1.76a3,3,0,0,0-.6,0q.3,0,.6,0h1.76l6.45.07h8.24a4.82,4.82,0,0,0,1.35-.31,4.32,4.32,0,0,0,2.12-1.88,4.86,4.86,0,0,0,.55-2.9,4.36,4.36,0,0,0-4.32-3.87H570a4.29,4.29,0,0,0-4.21,4.25,4.68,4.68,0,0,0,.25,1.74,4.29,4.29,0,0,0,1.74,2.17,4.17,4.17,0,0,0,1.67.58A2.69,2.69,0,0,0,570,243.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M571.46,233.94a110.16,110.16,0,0,0,13.27,0,110.16,110.16,0,0,0-13.27,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M622.81,330.38l6.2-.45c-1.62-22.18-4-35.45-7.25-40.57-6.26-9.83-12.47-11.61-19.36-12.78-6.41-1.09-12.87-.84-19.13-.58l-1.55.06c-12.91.5-40,.06-40.26.06l-.1,6.19c.27,0,27.49.46,40.58-.05l1.55-.07c5.94-.23,12.07-.48,17.84.51,6.16,1,10.26,2.24,15.2,10C618,295,620.82,303.06,622.81,330.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M518.88,77.7H252.4A19.28,19.28,0,0,0,233.12,97V280.8h305V97A19.28,19.28,0,0,0,518.88,77.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M519.07,82H253.33a15.9,15.9,0,0,0-15.9,15.9V276.47H533.85V96.81A14.78,14.78,0,0,0,519.07,82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "293.25 112.34 247.59 101.64 249.4 96.78 293.25 112.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "483.56 123.37 451.81 115.94 453.06 112.56 483.56 123.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "333.8 218.25 289.96 201.58 292.39 197 333.8 218.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M581.52,173.87a1.84,1.84,0,0,0,.29.24l.85.62,3.18,2.2c2.7,1.82,6.47,4.32,10.66,7s8,5.07,10.84,6.76c1.4.85,2.53,1.55,3.32,2l.92.51a1.29,1.29,0,0,0,.33.17,1.57,1.57,0,0,0-.29-.23l-.87-.59-3.26-2.08-10.75-6.86L586,176.69l-3.26-2.09-.9-.55A2.21,2.21,0,0,0,581.52,173.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M594.75,177.37a2.78,2.78,0,0,0,.29.24l.85.62c.78.52,1.84,1.27,3.19,2.19,2.7,1.83,6.47,4.32,10.65,7s8,5.07,10.84,6.76c1.4.85,2.54,1.55,3.33,2l.91.52a1.24,1.24,0,0,0,.33.15,1.51,1.51,0,0,0-.28-.22L624,196l-3.25-2.1L610,187.05l-10.72-6.9L596,178.06l-.89-.55A1.51,1.51,0,0,0,594.75,177.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M659.94,199.91a2,2,0,0,0,.24-.68c.12-.44.29-1.09.49-1.9a28.32,28.32,0,0,0,.77-6.42,13.89,13.89,0,0,0-1.47-6.3,9.67,9.67,0,0,0-1.1-1.65,2.42,2.42,0,0,0-.51-.5,26.36,26.36,0,0,1,1.36,2.28,14.85,14.85,0,0,1,1.33,6.19,34.12,34.12,0,0,1-.69,6.37A19.17,19.17,0,0,0,659.94,199.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M691.47,254.81a5.75,5.75,0,0,0,0-.83c0-.56,0-1.36-.05-2.32-.06-2-.21-4.74-.45-7.75s-.53-5.76-.77-7.74c-.13-1-.24-1.79-.32-2.32a3.93,3.93,0,0,0-.18-.84,3.1,3.1,0,0,0,0,.86l.2,2.32c.17,2.08.4,4.77.66,7.75s.41,5.66.56,7.74c.07.93.13,1.71.18,2.32A3.16,3.16,0,0,0,691.47,254.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M606.61,269.84c0,.08,1.5.29,3.81,1a30.92,30.92,0,0,1,4,1.6,30,30,0,0,1,8.38,6.2,30.65,30.65,0,0,1,2.72,3.29c1.4,2,2.06,3.36,2.12,3.32a5.61,5.61,0,0,0-.43-1,8.93,8.93,0,0,0-.59-1.1c-.25-.42-.52-.91-.87-1.41a27.34,27.34,0,0,0-2.68-3.39,31.69,31.69,0,0,0-4-3.54,31,31,0,0,0-4.53-2.71,26.6,26.6,0,0,0-4-1.55c-.58-.19-1.13-.3-1.6-.42a10.63,10.63,0,0,0-1.23-.23A5.49,5.49,0,0,0,606.61,269.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M530.37,223.09a1.82,1.82,0,0,0,0-.33v-1c0-.89,0-2.15,0-3.76.05-3.28.11-8,.19-13.81.21-11.69.5-27.78.82-45.57s.58-33.91.69-45.57c.06-5.83.07-10.55.06-13.81V94.2a1.93,1.93,0,0,0,0,.34v1c0,.88,0,2.14,0,3.76,0,3.28-.11,8-.19,13.8-.21,11.69-.5,27.78-.82,45.58s-.59,33.9-.69,45.56c-.06,5.84-.08,10.55-.07,13.81v4.74A1.82,1.82,0,0,0,530.37,223.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M427.37,172.32c5-15.15-5.43-44.5-51.36-39.8,74.44-32.36,77,15.62,51.36,39.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M345.26,156.13c-5,15.15,5.43,44.5,51.37,39.8-74.44,32.36-77-15.62-51.37-39.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "339.48 150.19 336.74 150.19 336.74 150.64 334.65 150.64 334.65 149.54 332.75 149.54 332.75 152.56 333.02 152.56 333.02 153.01 334.92 153.01 334.92 152.56 337.02 152.56 337.02 151.88 339.48 151.88 339.48 150.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 337.51,
    y: 144.02,
    width: 1.9,
    height: 1.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "336.59 144.36 334.69 144.36 334.69 145.81 333.2 145.81 333.2 147.17 335.57 147.17 335.57 146.27 336.59 146.27 336.59 144.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "330.58 153.07 330.58 151.48 328.07 151.48 328.07 152.13 328.07 153.07 328.07 153.23 326.44 153.23 326.44 154.82 328.19 154.82 328.19 156.39 330.13 156.39 330.13 154.44 329.47 154.44 329.47 153.07 330.58 153.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "327.73 162.46 326.68 162.46 325.93 162.46 325.72 162.46 325.72 161.05 326.35 161.05 326.35 159.92 325.12 159.92 322.97 159.92 321.34 159.92 321.34 161.86 324.46 161.86 324.46 164.94 324.88 164.94 325.72 164.94 326.68 164.94 326.68 163.88 327.73 163.88 327.73 162.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 328.64,
    y: 160.99,
    width: 1.83,
    height: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 320.46,
    y: 166.62,
    width: 1.93,
    height: 1.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "325.2 171.07 324.02 171.07 323.28 171.07 322.1 171.07 322.1 174.03 324.02 174.03 324.02 172.94 325.2 172.94 325.2 171.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 316.22,
    y: 168.41,
    width: 2.94,
    height: 2.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "316.09 178.98 316.09 177.12 314.12 177.12 314.12 180.06 315.34 180.06 315.34 181.47 317.3 181.47 317.3 178.98 316.09 178.98"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 317.55,
    y: 188.99,
    width: 1.96,
    height: 2.99
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "317.64 193.64 317.64 192.15 315.68 192.15 315.68 195.13 316.98 195.13 317.64 195.13 318.94 195.13 318.94 193.64 317.64 193.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 317.28,
    y: 172.86,
    width: 1.84,
    height: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 319.22,
    y: 182.41,
    width: 2.85,
    height: 1.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 320.02,
    y: 193.36,
    width: 2.58,
    height: 3.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "317.56 184.92 315.53 184.92 315.53 186.17 313.02 186.17 313.02 189.68 315.81 189.68 315.81 188.42 317.56 188.42 317.56 184.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 318.95,
    y: 175.68,
    width: 1.95,
    height: 2.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "316.43 197.43 316.43 195.76 313.77 195.76 313.77 198.42 315.75 198.42 315.75 199.79 318.18 199.79 318.18 201.39 320.21 201.39 320.21 199.79 320.21 199.02 320.21 197.43 316.43 197.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "331.2 213.15 331.2 211.54 331.2 210.55 329.41 210.55 329.41 210.52 329.41 209.85 329.41 209.05 326.71 209.05 326.71 210.52 327.48 210.52 327.48 213.81 328.81 213.81 329.33 213.81 329.33 214.8 329.75 214.8 331.2 214.8 333.29 214.8 333.29 213.15 331.2 213.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "341.98 213.02 341.98 209.88 338.06 209.88 338.06 210.94 334.35 210.94 334.35 216 335.11 216 339.17 216 339.93 216 339.93 214.68 339.17 214.68 339.17 213.02 341.98 213.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "347.68 215.48 344.45 215.48 343.51 215.48 341.78 215.48 341.78 216.85 338.86 216.85 338.86 218.83 344.45 218.83 344.45 217.88 344.45 217.61 347.68 217.61 347.68 215.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "328.86 204.98 328.86 204.63 328.86 204.11 328.86 203.2 326.82 203.2 326.82 204.26 325.38 204.26 325.38 202.78 324 202.78 324 201.45 321.44 201.45 321.44 203.48 322.87 203.48 322.87 204.31 318.83 204.31 318.83 206.34 320.75 206.34 320.75 207.86 325.38 207.86 325.38 206.34 325.38 205.83 325.38 205.69 327.43 205.69 327.43 206.45 328.42 206.45 328.86 206.45 330.36 206.45 330.36 204.98 328.86 204.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M420.59,193.1l-17.65.84,4.45,3.75h0a108.59,108.59,0,0,1-20.18,9.7c-12.29,4.37-23.06,6.58-32.14,6.58h-1.18a49.48,49.48,0,0,1-5.71-.46l0,1.43h1.95v2.82H348.3l.05,2a53.63,53.63,0,0,0,6,.45l1.31,0c9.09,0,19.27-1.6,30.87-5.29a142.29,142.29,0,0,0,22.56-9.53l4.55-2.38,4.1,3.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "432.48 178.88 435.22 178.88 435.22 178.43 437.31 178.43 437.31 179.53 439.21 179.53 439.21 176.51 438.94 176.51 438.94 176.05 437.04 176.05 437.04 176.51 434.94 176.51 434.94 177.19 432.48 177.19 432.48 178.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 432.55,
    y: 183.14,
    width: 1.9,
    height: 1.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "435.37 184.7 437.27 184.7 437.27 183.26 438.77 183.26 438.77 181.9 436.39 181.9 436.39 182.8 435.37 182.8 435.37 184.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "441.38 176 441.38 177.59 443.89 177.59 443.89 176.94 443.89 176 443.89 175.84 445.52 175.84 445.52 174.25 443.77 174.25 443.77 172.68 441.84 172.68 441.84 174.62 442.49 174.62 442.49 176 441.38 176"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "444.23 166.61 445.28 166.61 446.04 166.61 446.24 166.61 446.24 168.01 445.62 168.01 445.62 169.14 446.84 169.14 448.99 169.14 450.62 169.14 450.62 167.2 447.5 167.2 447.5 164.13 447.09 164.13 446.24 164.13 445.28 164.13 445.28 165.19 444.23 165.19 444.23 166.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 441.49,
    y: 166.25,
    width: 1.83,
    height: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 449.57,
    y: 160.52,
    width: 1.93,
    height: 1.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "446.76 158 447.94 158 448.68 158 449.86 158 449.86 155.03 447.94 155.03 447.94 156.13 446.76 156.13 446.76 158"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 452.81,
    y: 157.72,
    width: 2.94,
    height: 2.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "455.88 150.08 455.88 151.95 457.84 151.95 457.84 149.01 456.62 149.01 456.62 147.6 454.66 147.6 454.66 150.08 455.88 150.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 452.45,
    y: 137.09,
    width: 1.96,
    height: 2.99
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "454.31 135.43 454.31 136.92 456.28 136.92 456.28 133.94 454.98 133.94 454.31 133.94 453.02 133.94 453.02 135.43 454.31 135.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 452.84,
    y: 154.37,
    width: 1.83,
    height: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 449.89,
    y: 144.82,
    width: 2.85,
    height: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 449.36,
    y: 132.2,
    width: 2.58,
    height: 3.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "454.4 144.15 456.43 144.15 456.43 142.9 458.94 142.9 458.94 139.39 456.15 139.39 456.15 140.64 454.4 140.64 454.4 144.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 451.06,
    y: 150.75,
    width: 1.95,
    height: 2.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "455.53 131.64 455.53 133.31 458.19 133.31 458.19 130.64 456.22 130.64 456.22 129.27 453.78 129.27 453.78 127.68 451.75 127.68 451.75 129.27 451.75 130.04 451.75 131.64 455.53 131.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "440.76 115.92 440.76 117.52 440.76 118.51 442.55 118.51 442.55 118.55 442.55 119.22 442.55 120.01 445.25 120.01 445.25 118.55 444.48 118.55 444.48 115.26 443.15 115.26 442.63 115.26 442.63 114.27 442.21 114.27 440.76 114.27 438.67 114.27 438.67 115.92 440.76 115.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "429.98 116.04 429.98 119.18 433.9 119.18 433.9 118.12 437.61 118.12 437.61 113.07 436.85 113.07 432.79 113.07 432.03 113.07 432.03 114.38 432.79 114.38 432.79 116.04 429.98 116.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "424.28 113.58 427.51 113.58 428.45 113.58 430.18 113.58 430.18 112.22 433.1 112.22 433.1 110.24 427.51 110.24 427.51 111.19 427.51 111.45 424.28 111.45 424.28 113.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "443.1 124.08 443.1 124.44 443.1 124.95 443.1 125.87 445.14 125.87 445.14 124.8 446.59 124.8 446.59 126.28 447.96 126.28 447.96 127.61 450.52 127.61 450.52 125.58 449.09 125.58 449.09 124.76 453.13 124.76 453.13 122.73 451.21 122.73 451.21 121.21 446.59 121.21 446.59 122.73 446.59 123.24 446.59 123.38 444.53 123.38 444.53 122.62 443.54 122.62 443.1 122.62 441.6 122.62 441.6 124.08 443.1 124.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M351.37,136l17.65-.84-4.45-3.75h0a108.59,108.59,0,0,1,20.18-9.7c12.29-4.37,23.06-6.58,32.14-6.58h1.18a49.48,49.48,0,0,1,5.71.46l0-1.44h-1.95v-2.81h1.88l-.06-2a56,56,0,0,0-6-.46h-1.32c-9.08,0-19.27,1.59-30.87,5.29a141.37,141.37,0,0,0-22.56,9.53l-4.55,2.38-4.1-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M388.2,191.41l.17-.1.3-1.07s.23-.91.57-1.06,2.44-.84,2.44-.84c.68-.91-.11-1.25-.11-1.25a.59.59,0,0,1-.73-.27c-.3-.46.31-.61.73-1.07a.94.94,0,0,0,.11-1l.57-.53s-1,.19-.91,0a3.37,3.37,0,0,0,.26-.53c-1.18.76-5,.84-5,.84a18.36,18.36,0,0,1-2.55-.38c-.19-.15-.8.23-1.22.3a1,1,0,0,1-1-.49c-.23-.31.16-.61.16-.61l-.46.27a6,6,0,0,1-1.1-.27,8.2,8.2,0,0,0-1.72,0l-1.18.19a3.41,3.41,0,0,1-.53-.46c-.15-.19-1.06-.57-1.29-.76-.5-1-.84-.68-.84-.68a7.24,7.24,0,0,1-3.23-.12c-1-.95-2.25-.95-2.93-1.33s-2.51,1-2.51,1a16.29,16.29,0,0,1-1.75.84,5.62,5.62,0,0,1-1.41-.54l-.53-.57-.46-.45a8.27,8.27,0,0,1-.68-.88,8.91,8.91,0,0,0-.69-.8l-.23-.53a3.29,3.29,0,0,1-.64.08,3.81,3.81,0,0,1-1-.35,7.83,7.83,0,0,0-.12-1.14l-1-.57s0-.34,0-.45.68.64.68.64l.49,0s1.41-.11,1.68-.11A6.74,6.74,0,0,1,362,177s.23.23.45.42,1.33,0,1.33,0l1.07.53.15.35,1,.45a2.69,2.69,0,0,1,.95,0c.84,0,1-.07,1.07-.49s-.95-.42-.95-.42l-1-.15-1.49-.8-.34-.38-.72.12-1.11-.73c-.53-.45-1.82-.07-1.82-.07l-.91.07s-.8.15-1,.15a3.33,3.33,0,0,1-.8-.34l-.35-.3-.49-.12-.91-.76-.19-.38-.69-.19a2,2,0,0,1-.34-.57c-.11-.3.42-.76.42-.76.11-.72,3-.49,3.46-.46s.27.77.46,1.14a1.84,1.84,0,0,0,1.06.69c.27.08.8-.34.8-.34l-.72-.15s-.8-.27-.88-.8-.07-.5.69-.54,1-.95,1-.95c-.26-.95,1-.95,1-1.21a4.14,4.14,0,0,1,.57-1.11l.64-1a1.22,1.22,0,0,0,1.49-.87c.07-.16,1-.5,1-.5s.53.53.91.11a.53.53,0,0,0,0-.76,1.71,1.71,0,0,1-1.64-.87c-.42-.46.92-1.41,1.18-1.37s1.94-.19,2,.08.65.64.65.64.19-.11.26.35,1.18.19,1.18.19l.42-.54-.68-.53a2.22,2.22,0,0,0-.54-.84,1.37,1.37,0,0,1-1.21-.34l-.12-.53-.83-.31s-.35-.07-.23-.22,0-.88-.12-.88l-1,.08-.26-.19c-.5.11-1.56-.54-1.56-.54l0-.22a4.32,4.32,0,0,0,.68-1.83,8.32,8.32,0,0,1,.76-.72,12.37,12.37,0,0,0,1-1l-.23-.54c.83.31,1-.34,1-.34l-.69-.53a22.69,22.69,0,0,1-2.24-1.33c-.46-.38-.15-1.07-.15-1.07s.64-.65.95-.91a4.48,4.48,0,0,1,.72-.5l.76.92a.6.6,0,0,0,.72.11,2.44,2.44,0,0,1,2,1.26,3.58,3.58,0,0,1,0,2.09l.69,1.18.3,0,.72,1.07.76-.27.5.08a.58.58,0,0,0,.49.72.51.51,0,0,0,.69-.46s-.31-.42,0-.72,0-.84,0-.84l-.31-.76s.19-.61.39-.61.57-.38.57-.38l.57-.38,0-.61c1.52,1,.91-.72.91-.72l1.4-.15.5-.8-.57-1.1a1.48,1.48,0,0,1-.57-.39,6.08,6.08,0,0,1-.61-1.82l-.57-.34-.65.45-.53,0-.08.15-.38.08-.72-.38-.76.65s-2.21,1-3,1.48-2.93-.88-2.93-.88a1.87,1.87,0,0,0-1.44-.3.9.9,0,0,0-.57,1.26c.15.41-.27.76-.27.76s-.11.38-.72.38-.42.64-.42.64l.11.92-.61.57-.18.53a15.21,15.21,0,0,1-1.64.49,6.11,6.11,0,0,1-1.33,0,1.24,1.24,0,0,0-.84-.31c-.46,0-.49-.3-.49-.3a1.8,1.8,0,0,0-.16-.76c-.19-.5.76-1,1.11-.92s.8-.38.61-.95.53-.45.53-.45l.49-.38-1.18-.5a5.56,5.56,0,0,1-1.56,1c-.61.15-.42-.49-.64-.76s.15-.76.15-.76l1.14-1-.21-.17c-.06-.63,2.28-2.57,2.28-2.57a4.68,4.68,0,0,0-3.36,1.64c-5.78,7.05-8.23,15.92-5.86,24.42,0,0,1.63,7.15,11.68,9.7,0,0,1,.57,1.52.42a4,4,0,0,0,1,.27c.61.07.49.76.79,1.06s.08,1,.08,1,.19.88.65.95a.6.6,0,0,1,.49.54l.57.22a2.1,2.1,0,0,0,.73.65c.38.15,1.4.42,1.4.42s.73,0,.73.26,1,.54,1.14.54l.76,0s1.48.27,1.63.57a1.67,1.67,0,0,0,.65.53l2.36.69a4.32,4.32,0,0,0,.57.3,7.6,7.6,0,0,0,1.94.42,2.58,2.58,0,0,0,1.9.5s1.33.87,1.83.76a1.81,1.81,0,0,1,1.29.19c.38.19,1.11-.19,1.11-.19l1.25-.08s.65-.59.82-.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M419.22,157.35c-4.33-15.55-22.55-24-40.69-19a8.77,8.77,0,0,0,2.19.48l-.53.38a39.14,39.14,0,0,0,4.19-.53l1.59.45,1.14.61,2.74.3a4.67,4.67,0,0,0,2.14,4.72l-5.1.61-.08,1.22.23.61a1.43,1.43,0,0,1,1.29,1.37,7.16,7.16,0,0,1-.07,1.44l.15.69,2.81.45s-.07-.3.54-.45.6-1.68.15-2.06a3.39,3.39,0,0,0-1.3-.53l-.45-.76,1.06-.61,2.21.91s2.51.92.68,3.58l-1.29.76-.23,1-.3,1.6-.91.61s-1.76-.69-1.91-1.14-1.37-.31-1.37-.31l.31.38s2,.69,1.82,2l-.76.23-.33,0-1.11.12.38.38,1-.23,1.29-.23s3.5-.07,3,1.37-1.21,1.68-1.21,1.68-.76.53-.38,1.14a3.09,3.09,0,0,0,2.28,1.22s0-1,1.14-.84l-.23.53,1,.53a2.39,2.39,0,0,0-.45,1.15c0,.53.3,1.29-.39,2l.46,1s-1.6.38-1.37,1.37l.23,1-.46,1.07a3.93,3.93,0,0,1,1.07,2.13l1.6.45-.23.54,1.06.3.61.53.54-.6,1.59.15.53.76,1.53.3.3-.76,1.22-.68,1.06.53,1.37-1.45,1.75-.53.23-1.14,1-.53,1.37.61s.23-1.53,1-1.37,1.29-.08,1.29,2.43l2.44.23.61,1.45.6.15-.22,1.6-.61.91.76.83-.31.61s2.06.54,3-.91c0,0,3.35-4.87-.31-18.78m-11-3.21-1.52.91V156a12.37,12.37,0,0,1-2.21,1c-.23-.08-1.37,1-1.37,1l-1.83-.69-.53,1-.76.46c-.38-.31-.46.6-.46.6l-1.6.77-1.36-.46s-.23-.46-.76-1.67,1.14-2.13,1.14-2.13l.76-.69c1-.46.3-.76.3-.76.46-1.37,1.6-.91,2.36-.91a7.73,7.73,0,0,0,1.9-.38l.69-1.3,2.05.08.53-.61,2.13-.3.84,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M379.43,154l1.83-.53-.16.45s.61.23,0,.54-.83.45-1.67-.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "381.71 144.25 380.65 145.16 382.32 145.47 383.01 144.48 381.56 144.94 381.71 144.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "309.38 231.44 312.57 231.44 312.57 247.08 322.6 247.08 322.6 249.42 309.38 249.42 309.38 231.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M338.78,231.18a13.68,13.68,0,0,1,8.6,2.64,8,8,0,0,1,3.44,6.62,7.93,7.93,0,0,1-3.47,6.58,14.13,14.13,0,0,1-8.74,2.61,13.28,13.28,0,0,1-8.4-2.61,8,8,0,0,1-3.36-6.53,8.13,8.13,0,0,1,3.38-6.67,13.5,13.5,0,0,1,8.55-2.64m.13,2.45a9.87,9.87,0,0,0-6.29,1.93,6,6,0,0,0-2.46,4.93,5.9,5.9,0,0,0,2.47,4.84,10.85,10.85,0,0,0,12.41,0,6,6,0,0,0,2.49-4.91,5.89,5.89,0,0,0-2.49-4.8,9.67,9.67,0,0,0-6.13-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M369.24,240.56h7.48v7.62a24.63,24.63,0,0,1-8.17,1.45q-5.54,0-8.84-2.61a7.9,7.9,0,0,1-3.31-6.43,8.19,8.19,0,0,1,3.43-6.71,13.56,13.56,0,0,1,8.6-2.67,18.65,18.65,0,0,1,3.57.33,33,33,0,0,1,4.27,1.2v2.62a18.55,18.55,0,0,0-7.91-1.86,9.52,9.52,0,0,0-6.16,2,6.18,6.18,0,0,0,0,9.93,10.19,10.19,0,0,0,6.45,1.95,18.38,18.38,0,0,0,4.58-.71l.3-.08v-3.74h-4.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 383.86,
    y: 231.44,
    width: 3.19,
    height: 17.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "412.16 231.44 415.19 231.44 415.19 249.42 412.44 249.42 397.54 235.57 397.54 249.42 394.55 249.42 394.55 231.44 397.13 231.44 412.16 245.4 412.16 231.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "422.41 231.44 435.05 231.44 435.05 233.73 425.6 233.73 425.6 239.21 434.73 239.21 434.73 241.52 425.6 241.52 425.6 247.1 435.35 247.1 435.35 249.39 422.41 249.39 422.41 231.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "458.92 231.44 461.9 231.44 461.9 249.42 458.7 249.42 458.7 235.43 451.85 242.38 451.26 242.38 444.32 235.43 444.32 249.42 441.13 249.42 441.13 231.44 444.15 231.44 451.56 238.82 458.92 231.44"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 582.04,
    cy: 321.48,
    r: 37.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M619.13,320.84a.17.17,0,0,0,0,.1A37.12,37.12,0,0,1,544.9,322v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M608.08,321.09a26.06,26.06,0,1,1-26.45-25.67h0A26.06,26.06,0,0,1,608.08,321.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M581.64,295.42a26.06,26.06,0,0,1,26.44,25.67l-52.12.78A26.07,26.07,0,0,1,581.64,295.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "580.29 299.58 582.67 299.58 583.87 301.65 582.67 303.72 580.29 303.72 579.09 301.65 580.29 299.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "580.29 339.55 582.67 339.55 583.87 341.62 582.67 343.69 580.29 343.69 579.09 341.62 580.29 339.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "565.04 306.89 566.73 305.2 569.04 305.82 569.65 308.12 567.97 309.81 565.66 309.19 565.04 306.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "593.3 335.15 594.99 333.46 597.3 334.08 597.92 336.38 596.23 338.07 593.92 337.45 593.3 335.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "559.43 322.83 559.43 320.44 561.5 319.25 563.56 320.44 563.56 322.83 561.5 324.02 559.43 322.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "599.4 322.83 599.4 320.44 601.46 319.25 603.53 320.44 603.53 322.83 601.46 324.02 599.4 322.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "566.73 338.07 565.04 336.38 565.66 334.08 567.97 333.46 569.65 335.15 569.04 337.45 566.73 338.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "594.99 309.81 593.3 308.12 593.92 305.82 596.23 305.2 597.92 306.89 597.3 309.19 594.99 309.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M595.63,321.27a13.62,13.62,0,1,1-13.81-13.41h0A13.61,13.61,0,0,1,595.63,321.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M568.41,321.67a13.62,13.62,0,1,0,27.23-.4,13.83,13.83,0,0,0-.48-3.36,13.4,13.4,0,0,1-26.29,0A13,13,0,0,0,568.41,321.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 307.85,
    cy: 321.47,
    r: 37.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M344.93,320.83v.1A37.12,37.12,0,0,1,270.7,322v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M333.88,321.08a26.06,26.06,0,1,1-26.44-25.67h0A26,26,0,0,1,333.88,321.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M307.45,295.41a26,26,0,0,1,26.43,25.67l-52.11.78A26.07,26.07,0,0,1,307.45,295.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "306.09 299.57 308.48 299.57 309.67 301.64 308.48 303.71 306.09 303.71 304.9 301.64 306.09 299.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "306.09 339.54 308.48 339.54 309.67 341.61 308.48 343.68 306.09 343.68 304.9 341.61 306.09 339.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "290.85 306.88 292.54 305.19 294.84 305.81 295.46 308.11 293.77 309.8 291.47 309.18 290.85 306.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "319.11 335.14 320.8 333.45 323.1 334.07 323.72 336.37 322.03 338.06 319.73 337.44 319.11 335.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "285.23 322.82 285.23 320.43 287.3 319.24 289.37 320.43 289.37 322.82 287.3 324.01 285.23 322.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "325.2 322.82 325.2 320.43 327.27 319.24 329.34 320.43 329.34 322.82 327.27 324.01 325.2 322.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "292.54 338.06 290.85 336.37 291.47 334.07 293.77 333.45 295.46 335.14 294.84 337.44 292.54 338.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "320.8 309.8 319.11 308.11 319.73 305.81 322.03 305.19 323.72 306.88 323.1 309.18 320.8 309.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M321.44,321.26a13.62,13.62,0,1,1-13.81-13.41h0A13.61,13.61,0,0,1,321.44,321.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M294.21,321.66a13.62,13.62,0,1,0,27.23-.4,13.36,13.36,0,0,0-.47-3.36,13.4,13.4,0,0,1-26.29,0A13.41,13.41,0,0,0,294.21,321.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M356.64,326.13s5.66-52.65-48.9-52.65c-50.32,0-49.21,45.28-48.73,52.29h7.89s-4-44.63,40.84-44.63,41,45.54,41,45.54S352,326.51,356.64,326.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M327.42,278.94a1.69,1.69,0,0,0,.43.15c.29.1.71.2,1.24.39a39.91,39.91,0,0,1,4.44,1.72,35.51,35.51,0,0,1,19.52,23.23,38.68,38.68,0,0,1,.94,4.65c.08.56.12,1,.16,1.28a2.36,2.36,0,0,0,.08.45,1.69,1.69,0,0,0,0-.45,7.53,7.53,0,0,0-.09-1.3,32.81,32.81,0,0,0-.82-4.72,34.72,34.72,0,0,0-19.69-23.44,32.62,32.62,0,0,0-4.5-1.62c-.54-.16-1-.24-1.26-.31A1.71,1.71,0,0,0,327.42,278.94Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M189.05,337,182,347.69l-3.18,10a1.31,1.31,0,0,1-1.63.86l-.1,0h0a1.29,1.29,0,0,1-.83-.9c-.65-2.62-3-12.29-2.42-13s6.72-11.72,6.72-11.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.07,358.54l-2.76-14.66-.29.45a2,2,0,0,0-.29,1.33c.18,1.24.74,4.65,2.49,12a1.34,1.34,0,0,0,.83.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M178.74,341.79a.82.82,0,0,1-.37,1,.76.76,0,0,1-1-.36.82.82,0,0,1,.39-1,.76.76,0,0,1,1,.49"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M177.59,352.26a3.74,3.74,0,0,1,1.48-.24,3.94,3.94,0,0,1,1.4.55,1,1,0,0,0-.29-.39,2.06,2.06,0,0,0-1.08-.44A1.9,1.9,0,0,0,178,352C177.68,352.09,177.57,352.24,177.59,352.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M177.44,354.2a3.85,3.85,0,0,1,2.39.67c.07,0-.3-.6-1.06-.83A1.43,1.43,0,0,0,177.44,354.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M177.33,349.5a12.73,12.73,0,0,1,1.95.09,10.73,10.73,0,0,1,1.83.64,2.86,2.86,0,0,0-1.78-.92A2.94,2.94,0,0,0,177.33,349.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M179.21,346.08c0,.09.75.21,1.54.68s1.29,1,1.36,1a3.31,3.31,0,0,0-2.9-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M181.21,342.9a6.64,6.64,0,0,1,1.66.67,6.57,6.57,0,0,1,1.21,1.26,1.22,1.22,0,0,0-.16-.52,2.86,2.86,0,0,0-2.12-1.45C181.42,342.83,181.21,342.87,181.21,342.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M183.2,343a1.2,1.2,0,0,0,.26-.4,3.14,3.14,0,0,0,.36-1.27,1.52,1.52,0,0,0-.16-.94.52.52,0,0,0-.56-.23.92.92,0,0,0-.48.39,1.83,1.83,0,0,0,.45,2.31,2.15,2.15,0,0,0,2.39.18.72.72,0,0,0,.35-.5.5.5,0,0,0-.3-.52,1.82,1.82,0,0,0-.95-.09,3.8,3.8,0,0,0-1.27.38,1.31,1.31,0,0,0-.4.26,6.36,6.36,0,0,1,1.66-.44,1.67,1.67,0,0,1,.83.09.28.28,0,0,1,.18.29.53.53,0,0,1-.26.31,1.94,1.94,0,0,1-2.07-.17,1.66,1.66,0,0,1-.41-2,.65.65,0,0,1,.32-.29.29.29,0,0,1,.31.12,1.21,1.21,0,0,1,.15.83A5.18,5.18,0,0,1,183.2,343Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M195.78,343.13l.83,10.68S186,357.44,186,359.43l20.76-.05-.58-16.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M203,352.66a.8.8,0,0,1-.3,1.57.9.9,0,0,1-.66-1,.83.83,0,0,1,1-.54"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M206.69,359.38l-.05-1.66-20.07.75a1.47,1.47,0,0,0-.77,1.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M196.25,353.72c0,.1.51.13,1,.43s.83.73.88.68a1.2,1.2,0,0,0-.71-1C196.83,353.49,196.22,353.63,196.25,353.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M194.11,354.71c0,.1.42.25.79.66s.47.83.58.83.14-.58-.33-1.08S194.11,354.61,194.11,354.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M193,357.35c.09,0,.22-.5-.07-1.05s-.76-.74-.83-.65.27.37.49.83S192.87,357.35,193,357.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M196.33,351.26c0,.1.51-.06,1.08-.05s1,.18,1.08.1-.39-.44-1.07-.45S196.28,351.19,196.33,351.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "195.94 345.25 196.08 347.15 206.29 346.65 206.23 344.93 195.94 345.25"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M196.21,349.11a1.94,1.94,0,0,0,1-.05,4.55,4.55,0,0,0,1.07-.38,4.3,4.3,0,0,0,.59-.34,1.06,1.06,0,0,0,.3-.26.45.45,0,0,0,0-.54.6.6,0,0,0-.45-.21,1.78,1.78,0,0,0-.39.07,3.71,3.71,0,0,0-.63.24,3.77,3.77,0,0,0-.94.68c-.47.46-.62.83-.58.83s.27-.29.74-.68a4.12,4.12,0,0,1,.92-.56,3,3,0,0,1,.59-.21c.21-.06.39-.07.46,0s0,.05,0,.12a1,1,0,0,1-.21.19q-.27.18-.54.33a5.39,5.39,0,0,1-1,.43A6.68,6.68,0,0,0,196.21,349.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M196.35,349.25a1.73,1.73,0,0,0,.23-1,3.48,3.48,0,0,0-.47-1.75.82.82,0,0,0-.69-.5.48.48,0,0,0-.42.3,1.86,1.86,0,0,0-.1.39,2.37,2.37,0,0,0,.52,1.76c.43.52.83.63.83.59a3.64,3.64,0,0,1-.66-.74,2.4,2.4,0,0,1-.37-1,2.08,2.08,0,0,1,0-.61c0-.22.09-.39.18-.38a.74.74,0,0,1,.38.33,3.55,3.55,0,0,1,.28.55,3.68,3.68,0,0,1,.24,1C196.38,348.85,196.29,349.23,196.35,349.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M188.19,255.23s-3.81,7.81-4.81,13.38c-.28,1.58,10.91,81.67,10.91,81.67l13.23-.5-6.2-74.53,2.21-14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M220.34,260.07a120,120,0,0,1-.83,16.19c-1,7.85-3.23,16.79-4,21.79-1.61,11.06-4.78,13.15-4.78,13.15l-25.39,32.49-10-9,22.42-35.81s6-39.73,5.75-38.66S220.34,260.07,220.34,260.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M210.24,311.69a3.53,3.53,0,0,1-.24.34l-.72.93-2.67,3.43c-2.25,2.93-5.31,6.95-8.71,11.39s-6.48,8.48-8.77,11.35c-1.14,1.44-2.08,2.59-2.74,3.38l-.77.9a2.7,2.7,0,0,1-.28.31,2.08,2.08,0,0,1,.24-.34l.72-.94L189,339l8.71-11.4c3.38-4.46,6.48-8.48,8.77-11.34,1.14-1.45,2.08-2.59,2.73-3.38L210,312A2.54,2.54,0,0,1,210.24,311.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M213.07,266.15a2.79,2.79,0,0,0,.36,1.27,8.14,8.14,0,0,0,4.53,4.25,3,3,0,0,0,1.29.28,10.83,10.83,0,0,1-6.18-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M185.67,261.62a3.45,3.45,0,0,0,3.72-.55c-.06-.11-.83.25-1.84.39A16,16,0,0,0,185.67,261.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M200,272.66a5.34,5.34,0,0,0-.09.53c-.05.39-.11.89-.19,1.53-.15,1.37-.37,3.32-.64,5.7-.52,4.88-1.22,11.62-2,19.38v-.1l-3.67,5.88-12.78,20.57c-1.6,2.61-2.91,4.74-3.83,6.26l-1,1.69a4.54,4.54,0,0,0-.32.62,4.6,4.6,0,0,0,.4-.58l1.1-1.66,3.94-6.18c3.32-5.27,7.86-12.51,12.89-20.49l3.66-5.89h0v-.05c.75-7.73,1.42-14.5,1.89-19.39l.51-5.72c.05-.64.1-1.14.12-1.53A2.2,2.2,0,0,0,200,272.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M203.82,202.87l-7.92,2.54-.6,16.8s-4.28,19.73-5.21,22.22a51.51,51.51,0,0,0-2.42,9.2s1.53,11.15,12.66,12.46,21.5-5.08,21.5-5.08,3.71-16.61,7.12-31.5c3.23-14.18.6-22.63.6-22.63l-12.2-4.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 200.52,
    y: 209.93,
    width: 1.88,
    height: 7.33,
    transform: "translate(-34.79 387.94) rotate(-83.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M196.18,192.13a1.66,1.66,0,0,1,1.77-1.38,1.39,1.39,0,0,1-.27-1.94,1.41,1.41,0,0,1,.45-.39,2.84,2.84,0,0,1,.59-3.78l8.36,11.53a6.08,6.08,0,0,1-4.61,1.26,12.29,12.29,0,0,1-4.61-1.66,1.89,1.89,0,0,1-.91-.83c-.16-.39.06-.95.49-1A1.67,1.67,0,0,1,196.18,192.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M217,185.82a.79.79,0,0,1,1,.59.81.81,0,0,1-.12.64,1.39,1.39,0,0,1,1.57,1.19,1.44,1.44,0,0,1-.13.79,2.72,2.72,0,0,1,1.66.46,1.56,1.56,0,0,1,.67,1.55,1.13,1.13,0,0,1-1.33.83,1.56,1.56,0,0,1-.08,1.66,1,1,0,0,1-1.41.15,1.14,1.14,0,0,0-.11-.11,1.2,1.2,0,0,1-1.48,1.79,1.31,1.31,0,0,1-2.1,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M216.43,183.62,216.8,204a6.37,6.37,0,0,1-5.81,6.44h0a6.36,6.36,0,0,1-6.89-5.77c0-.14,0-.27,0-.41,0-1.94-.07-3.54-.07-3.54s-5-.33-5.47-5.23c-.29-2.84-.36-9.31-.38-14.29a6.47,6.47,0,0,1,5.89-6.46l3-.25a9.13,9.13,0,0,1,9.41,8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M204,200.75a11.88,11.88,0,0,0,6.23-2.49S209,202,204.05,202Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M199.55,186.22c.09.09.58-.35,1.34-.42s1.34.27,1.41.17-.06-.21-.32-.36a1.89,1.89,0,0,0-2.2.21C199.56,186,199.5,186.18,199.55,186.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M207.52,186.55a.71.71,0,0,0,.74.64.67.67,0,0,0,.68-.67h0a.71.71,0,0,0-.74-.65.68.68,0,0,0-.68.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M200.22,187.21a.71.71,0,0,0,.74.65.68.68,0,0,0,.66-.7h0a.71.71,0,0,0-.74-.65.67.67,0,0,0-.66.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M206.88,185.58c.1.08.59-.36,1.35-.43s1.35.27,1.42.17-.07-.21-.32-.36a1.93,1.93,0,0,0-2.21.2C206.9,185.36,206.84,185.53,206.88,185.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M204.64,191.41a4.89,4.89,0,0,0-1.27-.11c-.2,0-.38,0-.42-.15a1,1,0,0,1,.07-.58c.15-.49.29-1,.44-1.52a23.28,23.28,0,0,0,.94-4,25.3,25.3,0,0,0-1.25,3.87c-.14.53-.28,1-.42,1.52a1.27,1.27,0,0,0,0,.77.51.51,0,0,0,.34.25,1,1,0,0,0,.34,0A4.61,4.61,0,0,0,204.64,191.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M206.91,191.74c-.12,0-.06.83-.71,1.47s-1.52.63-1.52.74.21.14.58.12a2.07,2.07,0,0,0,1.28-.58,1.81,1.81,0,0,0,.54-1.22C207.08,191.92,207,191.73,206.91,191.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M206.47,183.13c.1.2.83,0,1.74.07s1.66.21,1.73,0-.1-.27-.41-.45a3,3,0,0,0-1.31-.33,3,3,0,0,0-1.33.27C206.59,182.87,206.44,183,206.47,183.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M199.45,184.05c.15.16.66-.06,1.28-.13s1.17,0,1.27-.17-.05-.26-.3-.4a1.86,1.86,0,0,0-2,.24C199.45,183.82,199.39,184,199.45,184.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M215.1,187.44c.09,0,3.33-1.29,3.48,2.08a2.53,2.53,0,0,1-3.24,2.76C215.32,192.18,215.1,187.44,215.1,187.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M216.29,191l.17.08a.66.66,0,0,0,.44,0,1.48,1.48,0,0,0,.6-1.34,2.42,2.42,0,0,0-.21-.83.75.75,0,0,0-.47-.42.3.3,0,0,0-.34.18v.17a.21.21,0,0,1-.06-.19.38.38,0,0,1,.13-.22.51.51,0,0,1,.31-.11.84.84,0,0,1,.64.49,2,2,0,0,1,.26.93,1.53,1.53,0,0,1-.77,1.51.64.64,0,0,1-.54-.06C216.31,191,216.28,191,216.29,191Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M217,187.15a1.76,1.76,0,0,0-1.54,1c-.17.49-.17,1-.35,1.54s-.63,1-1.15.9a1,1,0,0,1-.77-.7,2.67,2.67,0,0,1-.1-1.09c0-1.58.24-3.17.17-4.75a8.22,8.22,0,0,0-1.39-4.48,4.45,4.45,0,0,0-4.16-1.86c-1,.17-1.94.83-3,1a4.18,4.18,0,0,1-3.51-.83c-.13-.1-.68-.4-.68-.4a1.89,1.89,0,0,1,.26-1.07c1.89-2.09,5.55-3,8.31-2.49a9.84,9.84,0,0,1,6.88,4.57c1.39,2.45,1.36,6,.94,8.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M197.56,180.4a3.21,3.21,0,0,0,2.82,1.49,8.84,8.84,0,0,0,3.23-.77,25.9,25.9,0,0,1,5-1.19c.16,0,.36,0,.44-.17s-.11-.41-.3-.54c-1.56-1-5.16-1.4-7-1.32a5.48,5.48,0,0,0-4.61,2.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M198.05,180.5a6,6,0,0,1,3.94-2.22,16.25,16.25,0,0,1,15.14,7.59,21.2,21.2,0,0,0,.45-4.35,9.57,9.57,0,0,0-7.47-8.23S200.55,170.54,198.05,180.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M216.47,184.6a24.15,24.15,0,0,0-8.14-6.53,47.27,47.27,0,0,0-11.62-3.58,7.55,7.55,0,0,0-3.14-.06,2.83,2.83,0,0,0-2.14,2.1c-.2,1.29,2.23,3.06,3.32,3.73a36.44,36.44,0,0,0,3.4,1.62s-.24-2.35,3.5-3.17C206.75,177.59,216.47,184.6,216.47,184.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M192.91,174.6c.36-.07.71-.13,1.07-.17a14.79,14.79,0,0,1,3,.2,45.51,45.51,0,0,1,9.45,2.68,26.21,26.21,0,0,1,8.31,5.15,12.19,12.19,0,0,1,1.89,2.28c.36.6.51,1,.54.94s0-.1-.07-.27a5.63,5.63,0,0,0-.33-.76,10.39,10.39,0,0,0-1.83-2.4,24.27,24.27,0,0,0-8.35-5.33,39.77,39.77,0,0,0-9.57-2.59,12.21,12.21,0,0,0-3-.06,2.59,2.59,0,0,0-.83.2C193,174.54,192.9,174.58,192.91,174.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M205,175.9a12.07,12.07,0,0,0-3.83-.93,4.56,4.56,0,0,1,1-.7,9.62,9.62,0,0,1,3,.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M197.49,182.16a1.48,1.48,0,0,1,.34-2.07,1.5,1.5,0,0,1,.76-.28,1.36,1.36,0,0,1-.76-1.77l0-.09a1.71,1.71,0,0,1,2-.77,2.4,2.4,0,0,1,1.53,1.56,1.62,1.62,0,0,1,2.25-.43,1.68,1.68,0,0,1,.51.55.87.87,0,0,1,1.05-.55,3.09,3.09,0,0,1,1.13.67,2,2,0,0,0,1.19.54l.29.13a1.85,1.85,0,0,1-2.34.7,1.3,1.3,0,0,1-2.4.72,1.3,1.3,0,0,1-1.57,1,1.44,1.44,0,0,1-.48-.24,1.66,1.66,0,0,1-2.15,1,1.82,1.82,0,0,1-.43-.24,2.81,2.81,0,0,0-.31,2.28A1.5,1.5,0,0,1,197,183a1.58,1.58,0,0,1,.52-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M211.53,181.33a22.41,22.41,0,0,1,3.32,1.84A7.29,7.29,0,0,1,217.3,186l-1.66,1.59c-.46.15-.83.31-1.18,0a1.42,1.42,0,0,1-.48-1.28,1.23,1.23,0,0,1-1.46-.94,1.21,1.21,0,0,1,.07-.75,1,1,0,0,1-.7-.66,1,1,0,0,1,.24-.93,1,1,0,0,1-.9-1,.94.94,0,0,1,.3-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M195.9,205.41s-4.91,3-6.38,5.57-9.34,21.77-9,24.91S188.2,241,188.2,241l7.7-10-3.52-2.1,3.52-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M188.19,240.94s17.83,3.57,24.31-4.15l-1.88-6.52s-11.78,2.79-15.47,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M186.34,225.1c-.06.13,2.1,1,4.35,2.75s3.67,3.58,3.78,3.49a4.37,4.37,0,0,0-.83-1.26,16.53,16.53,0,0,0-2.65-2.57,17.43,17.43,0,0,0-3.16-1.9A4.62,4.62,0,0,0,186.34,225.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M192.06,228.66a18.26,18.26,0,0,0,1.61-3.18,23.71,23.71,0,0,0,1.46-3.25,10.57,10.57,0,0,0-1.85,3.07A12.88,12.88,0,0,0,192.06,228.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M195.3,220.6a13.75,13.75,0,0,1,.43-2.78,15,15,0,0,1,.73-2.72A27.89,27.89,0,0,1,195.3,220.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M227.32,207.9c-.34.36-5.24,3.61-6.88,9.13s-3.43,11.3-3.43,11.3l-6.39.84,3.6,14.72A17.17,17.17,0,0,0,226.17,236a79.58,79.58,0,0,0,6.88-15.68S232.51,202.47,227.32,207.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M212.81,228.87s2.71-6.06,3.08-6.14,5.58-1.92,5.58-1.92a1.87,1.87,0,0,1,0,1.32l1.89.24s-.28,1.16-.92,1.32l.68.6a3.81,3.81,0,0,1-1.28,1.08,1.42,1.42,0,0,1-1.24,0s.23.43-.83,1.11-2.91,1.66-2.91,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M212.82,228.87h0c.12-.24,2.72-6.07,3.08-6.15s5.55-1.92,5.6-1.92h0a2,2,0,0,1,0,1.32l1.87.24h0s-.28,1.13-.9,1.32l.62.65h0a3.89,3.89,0,0,1-1.29,1.09,1.5,1.5,0,0,1-1.21,0c.07.12.09.52-.83,1.1s-2.91,1.66-2.91,1.66h0Zm8.69-8.06c-.28.1-5.3,1.86-5.58,1.92s-2.1,4-3.05,6.11l4-.7c.07,0,1.87-1,2.91-1.66s.83-1.1.83-1.1v0h0a1.4,1.4,0,0,0,1.23,0,3.72,3.72,0,0,0,1.27-1.06l-.69-.61h0c.59-.15.91-1.16.91-1.29l-1.89-.25h0A1.8,1.8,0,0,0,221.51,220.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M221.31,222.15a25,25,0,0,1-3.42,1.34,11.17,11.17,0,0,0-1.33.48,1.7,1.7,0,0,0-.78.74c-.32.57-.43,1-.48,1a2.53,2.53,0,0,1,.29-1,1.92,1.92,0,0,1,.83-.88,11.34,11.34,0,0,1,1.37-.52A25.08,25.08,0,0,1,221.31,222.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M222.53,223.68a2.64,2.64,0,0,1-.95.34c-.6.16-1.44.3-2.34.54a6.23,6.23,0,0,0-2.12,1c-.48.38-.69.7-.73.68a1.86,1.86,0,0,1,.6-.83,5.32,5.32,0,0,1,2.17-1.13c.93-.24,1.78-.34,2.38-.45A4.08,4.08,0,0,1,222.53,223.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M217.74,226.45a2.15,2.15,0,0,1,1.25-.83,2.38,2.38,0,0,1,1.51-.14c0,.09-.66.13-1.42.41A13.48,13.48,0,0,1,217.74,226.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M211.17,230.73l-16.1-8.12-2.95,6s14.84,14.7,21.79,14.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M221,213.71a4.88,4.88,0,0,1-.22,1.2c-.17.72-.42,1.72-.72,2.81s-.58,2.1-.83,2.81a5.1,5.1,0,0,1-.41,1.13,6.06,6.06,0,0,1,.21-1.19c.18-.72.43-1.72.72-2.82s.59-2.08.83-2.79A5.86,5.86,0,0,1,221,213.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M220.25,233.7c-.05,0-.19-.74-.56-1.89a5.9,5.9,0,0,0-1-1.86,3.41,3.41,0,0,0-2.06-1.29,8.13,8.13,0,0,0-2.55.29l-2.11.42a3.49,3.49,0,0,0-.77.2.73.73,0,0,0-.39.4.57.57,0,0,0,0,.48s-.23-.13-.14-.51a.84.84,0,0,1,.43-.51,3.34,3.34,0,0,1,.83-.26l2.1-.48a7.9,7.9,0,0,1,2.65-.31,3.64,3.64,0,0,1,2.25,1.43,6,6,0,0,1,.94,2,11.84,11.84,0,0,1,.33,1.43A1.67,1.67,0,0,1,220.25,233.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M222.47,230.46a6.71,6.71,0,0,0-1.74-2,10.61,10.61,0,0,0-2.49-1.08,1.79,1.79,0,0,1,.83.07,4.75,4.75,0,0,1,1.8.78,4.37,4.37,0,0,1,1.33,1.47A1.62,1.62,0,0,1,222.47,230.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M233.05,220.36a.91.91,0,0,1-.09.31c-.08.21-.17.52-.3.88-.27.83-.64,1.89-1.11,3.23s-1,3-1.82,4.74a55.66,55.66,0,0,1-2.88,5.52,18.72,18.72,0,0,1-4,4.77,17.25,17.25,0,0,1-4.31,2.7,13.17,13.17,0,0,1-3.33.92,7,7,0,0,1-.93.09H214s.44-.05,1.24-.19a13.83,13.83,0,0,0,3.24-1,18.35,18.35,0,0,0,8.16-7.41c1.13-1.88,2-3.79,2.88-5.49a43.26,43.26,0,0,0,1.88-4.7c.51-1.38.9-2.45,1.2-3.2l.35-.83A1.66,1.66,0,0,1,233.05,220.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M228.43,208.25c0,.08-1.23.53-2.63,1.37s-2.41,1.71-2.49,1.66a10.06,10.06,0,0,1,5.1-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M216.22,247.37a7.18,7.18,0,0,1-.83.42c-.28.13-.61.28-1,.43s-.83.35-1.34.51a35,35,0,0,1-3.59,1,38.14,38.14,0,0,1-4.53.72,36.82,36.82,0,0,1-4.58.08,33,33,0,0,1-3.72-.39c-.52-.08-1-.18-1.4-.27s-.77-.17-1.06-.25a5.24,5.24,0,0,1-.88-.26,5.79,5.79,0,0,1,.91.16l1.05.2c.42.06.89.16,1.41.22a33,33,0,0,0,3.71.33,40.48,40.48,0,0,0,4.54-.11,37.73,37.73,0,0,0,4.49-.69c1.21-.26,2.4-.59,3.58-1,.51-.15,1-.33,1.35-.47s.73-.27,1-.38A6.59,6.59,0,0,1,216.22,247.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M203.14,255.73a13.58,13.58,0,0,1-3.26-.83,13.8,13.8,0,0,1-3.09-1.31c0-.07,1.43.46,3.18,1A31.71,31.71,0,0,1,203.14,255.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.85,241.38a31,31,0,0,0,11.16.16,12.15,12.15,0,0,1,4.15-.49,13.6,13.6,0,0,1,3.2,1.21A12.5,12.5,0,0,0,221.13,241a8.09,8.09,0,0,1-6.09,4.27,17.85,17.85,0,0,1-7.65-.68,20,20,0,0,0-4.53-.91c-2-.05-3.88.59-5.81.62a10.49,10.49,0,0,1-6.36-1.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.23,254.16a10.3,10.3,0,0,0,7.84,5,5.13,5.13,0,0,0,2.06-.17,2.53,2.53,0,0,0,1.56-1.3,7.33,7.33,0,0,0-2.43-1l-8.94-2.45"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M192.36,228.86a5.67,5.67,0,0,0,.73.74c.48.46,1.17,1.13,2,2s1.8,1.9,3,2.93,2.56,2.11,4,3.23a42.31,42.31,0,0,0,4.24,2.9,20.69,20.69,0,0,0,3.82,1.77,16.33,16.33,0,0,0,2.76.67,4.43,4.43,0,0,0,1,.06,31.46,31.46,0,0,1-3.69-1,23.34,23.34,0,0,1-3.72-1.83,44.14,44.14,0,0,1-4.15-2.91c-1.44-1.11-2.81-2.16-4-3.18s-2.18-2-3-2.84-1.6-1.46-2.11-1.89A4.32,4.32,0,0,0,192.36,228.86Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamion);
export default __webpack_public_path__ + "static/media/camion.9e3423c6cbb3197fe121ab7f79f98162.svg";
export { ForwardRef as ReactComponent };